import type { ReactNode } from 'react';

import { Sparkles } from 'lucide-react';
import { MotionDiv } from '@/shared/components/motion-div';

export const AssistantAvatar = () => {
  return (
    <div className="flex-center bg-rebranding-600 size-7 shrink-0 rounded-xl">
      <Sparkles className="text-primary size-3.5" />
    </div>
  );
};

export const AssistantMessageRow = ({ children }: { children: ReactNode }) => {
  return (
    <MotionDiv className="flex items-start gap-3">
      <AssistantAvatar />
      {children}
    </MotionDiv>
  );
};

export const UserMessageBubble = ({ children }: { children: ReactNode }) => {
  return (
    <div className="flex items-start justify-end">
      <div className="bg-foreground max-w-90 rounded-tl-lg rounded-br-lg rounded-bl-lg px-3 py-2">
        {children}
      </div>
    </div>
  );
};
